import axios from 'axios';
// export const  baseURL = 'https://frozen.dzyris.in/api/api'
// export const baseURL = 'http://localhost:4100/api'

export const baseURL = 'https://api.froz.dzyris.in'

const api = axios.create({
  baseURL // Base URL for the backend
});

// Export for use in components
export default api;

